import { findRegistration } from '~/Api/Analytics/VirtualBrand/Registration';
import { invokeApi, tryResolve } from '~/ApiClient';
import { handleError } from '~/ErrorHandler';
import { ThunkAction } from '~/Store';

import ActionTypes from './ActionTypes';
import { selectRegistrationById, State as RegistrationState } from './reducer';

export function fetchRegistration(id: string): ThunkAction<Promise<void>, any> {
	return async (dispatch) => {
		const request = dispatch(invokeApi(findRegistration, id));
		dispatch({ type: ActionTypes.request, request, id });

		await tryResolve(request, (response, error) => {
			dispatch({
				type: ActionTypes.receive,
				request,
				id,
				registration: response?.registration,
			});
			if (error) {
				dispatch(handleError(error));
			}
		});
	};
}

export function loadRegistration(id: string): ThunkAction<Promise<void>, any> {
	return async (dispatch, getState) => {
		await (selectRegistrationById(getState().medicinalBrandsAnalyticsRegistration, id)?.request ||
			dispatch(fetchRegistration(id)));
	};
}
